var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-container",attrs:{"id":"redirect-loading"}},[_c('div',{staticClass:"loading-text"},[_c('span',[_vm._v("H")]),_c('span',[_vm._v("S")]),_c('span',[_vm._v("E")])])])
}]

export { render, staticRenderFns }